import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FooterModule } from './../footer/footer.module';
import { NavbarModule } from './../navbar/navbar.module';
import { LayoutBasicComponent } from './layout-basic/layout-basic.component';
import { LayoutMainComponent } from './layout-main/layout-main.component';

const publicApi = [LayoutBasicComponent, LayoutMainComponent];

@NgModule({
  imports: [CommonModule, FooterModule, NavbarModule],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class LayoutModule {}
